/*
 * Core Util JS
 *
 * @author				Matt Gifford
 * @copyright			2020 Brigada Limited
 */
define("brigada/util", ["brigada/jquery"], (jQuery) => {
	/*
	 * @private	The private reference to this class
	 */
	const _this = {};


	/**
	 * Init
	 *
	 * @return        void
	 */
	_this.init = () => {
		// Initialise links
		_this.initLinks();

		// Initialise image maps
		_this.initImageMaps();

		// Social sharing
		_this.initSocialSharing();
	};


	/**
	 * Initialises the helpers for links
	 *
	 * @return        void
	 */
	_this.initLinks = () => {
		for (let node of document.getElementsByTagName('a')) {
			// Set the active class on links to the current page
			if ((node.href === window.location.href || node.href === `${window.location.href}index.html`) && !node.href.includes('#')) {
				node.classList.add('active');
			}
		}
	};


	/**
	 * Initialises the responsive image maps helper
	 *
	 * @return        void
	 */
	_this.initImageMaps = () => {
		// Responsive image map helper
		const __responsiveImageMaps = () => {
			for (let img of document.querySelectorAll('img[usemap]')) {
				// Check the native width and height have been saved
				if (!img.getAttribute('data-imagemap-width')) {
					// Create a temp copy of the image, and store the width and height
					const tempImage = new Image();
					tempImage.onload = () => {

						img.setAttribute('data-imagemap-width', tempImage.width);
						img.setAttribute('data-imagemap-height', tempImage.height);
						__responsiveImageMaps();
					};
					tempImage.src = img.src;
					return;
				}

				// Calculate the scale factor
				const scaleFactor = img.offsetWidth / parseInt(img.getAttribute('data-imagemap-width'), 10);

				// Find the image map areas
				const areas = document.querySelectorAll(`map[name=${img.getAttribute('usemap').replace('#', '')}] area`);

				// Scale the areas
				for (let area of areas) {
					// Check if the original coords have been saved
					if (!area.getAttribute('data-imagemap-coords')) {
						area.setAttribute('data-imagemap-coords', area.getAttribute('coords').replace(' ', '', 'g'));
					}

					// Process each coord
					const coords = area.getAttribute('data-imagemap-coords').split(',');
					for (let x = coords.length - 1; 0 <= x; x--) {
						coords[x] = parseInt(coords[x] * scaleFactor, 10);
					}

					// Save the new coords
					area.setAttribute('coords', coords.join(','));
				}
			}
		};

		// Add event handler to scale on browser resize
		window.addEventListener('resize', __responsiveImageMaps);

		// Set the initial size
		__responsiveImageMaps();
	};


	/**
	 * Validates the specified html form
	 *
	 *  Usage:
	 *
	 *        var fields = [
	 *        {name: 'name', title: 'Name'},
	 *        {name: 'email', title: 'Email', filter: 'email'}
	 *            ];
	 *
	 *        if (util.validateForm({form: document.getElementById('contactForm'), required: fields}) === false)
	 *        {
	 *			// Validation failed
	 *			return false;
	 *		}
	 *
	 * @param         obj            The description object of the form to validate
	 * @return        array
	 */
	_this.validateForm = obj => {
		let x;
		let y;
		let z;
		let errors = [];

		const errorHandler = (field, msg) => {
			field.classList.add('error');
			errors.push(msg);
		};

		// Get the form fields
		const form = obj.form;
		const fields = {
			inputs: form.getElementsByTagName('input'),
			selects: form.getElementsByTagName('select'),
			textareas: form.getElementsByTagName('textarea')
		};


		// Clear inline error handling on focus
		jQuery('input:not(.initialised), select:not(.initialised), textarea:not(.initialised)', form).on('focus',
			function () {
				jQuery(this).removeClass('error');
			});
		jQuery('input:not(.initialised), select:not(.initialised), textarea:not(.initialised)', form).addClass('initialised');

		// Validate the fields
		for (x = 0; x < obj.required.length; x++) {
			// Check the text input fields
			for (y = 0; y < fields.inputs.length; y++) {
				// Text and password fields
				if (fields.inputs[y].name === obj.required[x].name && (fields.inputs[y].type === 'text' || fields.inputs[y].type === 'password' || fields.inputs[y].type === 'hidden' || fields.inputs[y].type === 'email' || fields.inputs[y].type === 'file' || fields.inputs[y].type === 'search' || fields.inputs[y].type === 'number')) {
					// Check it has a value
					if ((fields.inputs[y].value.length < 1 || (!!fields.inputs[y].getAttribute(
						'placeholder') && fields.inputs[y].value === fields.inputs[y].getAttribute(
						'placeholder'))) && !obj.required[x].filter) {

						// Display an error message that the field can't be blank
						errorHandler(fields.inputs[y],
							('Please fill out the %s field').replace('%s', obj.required[x].title));
					}

					// Check for minimum length
					if (!!obj.required[x].minLength && fields.inputs[y].value.length < obj.required[x].minLength) {
						// Display an error message that the field is wrong length
						errorHandler(fields.inputs[y],
							('Please correct the %s field, the minimum length is %d characters').replace('%s',
								obj.required[x].title).replace('%d', obj.required[x].minLength));
					}

					// Check for maximum length
					if (!!obj.required[x].maxLength && obj.required[x].maxLength < fields.inputs[y].value.length) {
						// Display an error message that the field is wrong length
						errorHandler(fields.inputs[y],
							('Please correct the %s field, the maximum length is %d characters').replace('%s',
								obj.required[x].title).replace('%d', obj.required[x].maxLength));
					}

					// If it's an email address, check it's valid
					if (!!obj.required[x].filter && obj.required[x].filter === 'email') {
						const regex = /[a-z0-9_+-.]+@[a-z0-9_-]*\.?[a-z0-9_-]*\.?[a-z0-9_-]*\.[a-z]+$/i;
						if (regex.test(fields.inputs[y].value) === false || fields.inputs[y].value.indexOf(' ') !== -1) {
							errorHandler(fields.inputs[y],
								('Please ensure the %s field is a valid email address').replace('%s',
									obj.required[x].title));
						}
					}

					// Check if two fields should match
					if (!!obj.required[x].filter && obj.required[x].filter === 'match') {
						for (z = 0; z < fields.inputs.length; z++) {
							// Text and password fields
							if (fields.inputs[z].name === obj.required[x].match && (fields.inputs[z].type === 'text' || fields.inputs[z].type === 'password')) {
								if (fields.inputs[y].value !== fields.inputs[z].value) {
									errorHandler(fields.inputs[y],
										('Please ensure the %s fields match').replace('%s', obj.required[x].title));
								}
							}
						}
					}
				}

				// Checkbox fields, check it has been checked
				if (fields.inputs[y].name === obj.required[x].name && fields.inputs[y].type === 'checkbox' && fields.inputs[y].checked === false) {
					// Display an error message that the field can't be left unchecked
					// (this is un-formatted as it's often specific to the field in question, like agreeing to terms and conditions)
					errorHandler(fields.inputs[y], obj.required[x].title);
				}

				// Radio fields, check that one has been selected
				if (fields.inputs[y].name === obj.required[x].name && fields.inputs[y].type === 'radio') {
					let radioSelected = false;
					jQuery(`#${obj.form.id} input[name="${obj.required[x].name}"]`).forEach(
						radio => {
							if (radio.checked) {
								radioSelected = true;
							}
						});

					// Display an error message that the field can't be left unchecked
					// (this is un-formatted as it's often specific to the field in question, like agreeing to terms and conditions)
					if (radioSelected === false) {
						errorHandler(fields.inputs[y], obj.required[x].title);
					}
				}
			}

			// Check the select fields
			for (y = 0; y < fields.selects.length; y++) {
				// If the field name matches, check it has a selection other than the default
				if (fields.selects[y].name === obj.required[x].name && fields.selects[y].selectedIndex === 0) {
					// Display an error message that the field can't be left un-chosen
					errorHandler(fields.selects[y], ('Please select a %s').replace('%s', obj.required[x].title));
				}
			}

			// Check the text area fields
			for (y = 0; y < fields.textareas.length; y++) {
				// If the field name matches, check it has a value
				if ((fields.textareas[y].name === obj.required[x].name && fields.textareas[y].value.length < 1) || (!!fields.inputs[y].getAttribute(
					'placeholder') && fields.inputs[y].value === fields.inputs[y].getAttribute('placeholder'))) {
					// Display an error message that the field can't be blank
					errorHandler(fields.textareas[y],
						('Please fill out the %s field').replace('%s', obj.required[x].title));
				}
			}
		}

		// Return any errors
		return errors;
	};


	/**
	 * Add event handlers to social sharing links
	 *
	 * @return        void
	 */
	_this.initSocialSharing = () => {
		const popup = {width: 570, height: 400};
		const space = encodeURIComponent(' ');
		const sitename = jQuery('meta[property="og:site_name"]').length ? encodeURIComponent(
			jQuery('meta[property="og:site_name"]')[0].getAttribute('content')) : '';

		const shareUrls = {
			'facebook': 'https://www.facebook.com/sharer.php?t=%title%&u=%url%',
			'twitter': `https://twitter.com/intent/tweet?text=%title%${space}%url%`,
			'linkedin': `https://www.linkedin.com/shareArticle?mini=true&title=%title%&url=%url%${!!sitename.length ? '&source=' + sitename : ''}`,
			'googleplus': 'https://plus.google.com/share?url=%url%',
			'tumblr': 'https://www.tumblr.com/widgets/share/tool?title=%title%&canonicalUrl=%url%'
		};

		// Popup window
		let showSharingDialog = (url, width, height) => {
			const left = (((window.innerWidth || document.documentElement.clientWidth) - width) / 2);
			const top = (((window.innerHeight || document.documentElement.clientHeight) - height) / 2);
			const name = `popup${(new Date()).getTime()}`;

			// Open the window
			window.open(url, name, `left=${left},top=${top},width=${width},height=${height}`);
		};

		// Facebook
		jQuery(
			'.social-share--facebook:not(.init), .social-share--twitter:not(.init), .social-share--linkedin:not(.init), .social-share--googleplus:not(.init), .social-share--tumblr:not(.init)').addClass(
			'init').on('click', function (e) {
			e.preventDefault();
			e.stopPropagation();

			const url = !!this.getAttribute('data-share-url') ? encodeURIComponent(
				this.getAttribute('data-share-url')) : encodeURIComponent(window.location.href);

			const title = !!this.getAttribute('data-share-title') ? encodeURIComponent(
				this.getAttribute('data-share-title')) : encodeURIComponent(document.title);

			const network = this.className.match(/(facebook|twitter|linkedin|googleplus|tumblr)/).pop();

			showSharingDialog(shareUrls[network].replace(/%url%/g, url).replace('%title%', title), popup.width,
				popup.height);
		});

		// Email
		jQuery('.social-share--email:not(.init)').addClass('init').on('click', function (e) {
			e.preventDefault();
			e.stopPropagation();

			const url = !!this.getAttribute('data-share-url') ? encodeURIComponent(
				this.getAttribute('data-share-url')) : encodeURIComponent(window.location.href);

			const title = !!this.getAttribute('data-share-title') ? encodeURIComponent(
				this.getAttribute('data-share-title')) : encodeURIComponent(document.title);

			window.location = `mailto:?subject=${title}&body=%0D%0A${title}%0D%0A${url}%0D%0A%0D%0A`;
		});

		// Twitter / Reply
		jQuery('.social-share--reply:not(.init)').addClass('init').on('click', function (e) {
			e.preventDefault();
			e.stopPropagation();

			showSharingDialog(`https://twitter.com/intent/tweet?in_reply_to=${this.getAttribute('data-id')}`,
				popup.width, popup.height);
		});

		// Twitter / Re-tweet
		jQuery('.social-share--retweet:not(.init)').addClass('init').on('click', function (e) {
			e.preventDefault();
			e.stopPropagation();

			showSharingDialog(`https://twitter.com/intent/retweet?tweet_id=${this.getAttribute('data-id')}`,
				popup.width, popup.height);
		});

		// Twitter / Favorite
		jQuery('.social-share--favorite:not(.init)').addClass('init').on('click', function (e) {
			e.preventDefault();
			e.stopPropagation();

			showSharingDialog(`https://twitter.com/intent/favorite?tweet_id=${this.getAttribute('data-id')}`,
				popup.width, popup.height);
		});
	};


	/**
	 * Cookie object, provides cookie handling services
	 */
	_this.cookie = {
		/**
		 * Returns the value of the specified cookie
		 *
		 * @param        name        The name of the cookie to retrieve
		 * @return        The value of specified cookie, or NULL if there's no cookie set with that name
		 */
		get (name)
		{
			const nameEQ = `${name}=`;
			const ca = document.cookie.split(';');

			for (let c of ca) {
				while (c.charAt(0) === ' ') {
					c = c.substring(1, c.length);
				}
				if (c.indexOf(nameEQ) === 0) {
					return c.substring(nameEQ.length, c.length);
				}
			}

			return null;
		},


		/**
		 * Writes a cookie with the specified name, value and expiry
		 *
		 * @param        name        The name of the cookie to create/update
		 * @param        value        The value of the cookie to create/update
		 * @param        days            The number of days the cookie should remain set for, omit for until the browser exits
		 */
		set (name, value, days)
		{
			let expires = "";

			// Calculate expiry string
			if (arguments.length === 3) {
				const date = new Date();
				date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
				expires = `; expires=${date.toGMTString()}`;
			}

			// Set cookie
			document.cookie = `${name}=${value}${expires}; path=/`;
		},

		/**
		 * Deletes the specified cookie
		 *
		 * @param        name        The name of the cookie to delete
		 */
		clear (name)
		{
			this.set(name, "", -1);
		}
	};


	/**
	 * Scrolls a node into view
	 *
	 * @param        node        The node to scroll to
	 * @param        speed       The speed multiplier; default = 1.0
	 * @param        offset      Offset for the calculated position
	 * @return       void
	 */
	_this.scrollIntoView = function (node, speed, offset) {
		let y;
		let start;
		let end;

		if (arguments.length < 3) {
			offset = 0;
		}
		if (arguments.length < 2) {
			speed = 1;
		}

		// Get the scroll position
		y = node.offsetTop;
		while (node.offsetParent) {
			node = node.offsetParent;
			y += node.offsetTop;
		}

		start = ((!!document.documentElement && document.documentElement.scrollTop) ? document.documentElement.scrollTop : document.body.scrollTop);
		end = y + offset;

		// Start the animation
		jQuery('html, body').animate({
			scrollTop: end
		}, parseInt(Math.abs(end - start) * speed));
	};


	/**
	 * Returns if the document tab is visible/active, or registers a callback that receives change events
	 *
	 * @param        callback
	 * @return        bool
	 */
	_this.documentTabActive = function (callback) {
		let hidden, visibilityChange;

		if (typeof document.hidden !== "undefined") { // Opera 12.10 and Firefox 18 and later support
			hidden = "hidden";
			visibilityChange = "visibilitychange";
		} else if (typeof document.msHidden !== "undefined") {
			hidden = "msHidden";
			visibilityChange = "msvisibilitychange";
		} else if (typeof document.webkitHidden !== "undefined") {
			hidden = "webkitHidden";
			visibilityChange = "webkitvisibilitychange";
		}

		// Get current value
		if (arguments.length < 1) {
			if (hidden === undefined) {
				return true;
			}

			return !document[hidden];
		}

		// Set callback
		document.addEventListener(visibilityChange, function (e) {
			callback(!document[hidden]);
		}, false);
	};


	// Return the util object
	return _this;
});
